import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import MetricDeployment from './metric-deployment-model'
import {
  CreateMetricDeploymentAsync,
  DeleteMetricDeploymentAsync,
  LoadMetricDeploymentsAsync,
} from './metricDeployment-thunk'
const initialState: metricDeploymentSliceState = {
  metricDeployment: [],
  selected_metricDeployment: '',
  is_loading_metricDeployment: false,
  is_creating_metricDeployment: false,
  is_deleting_metricDeployment: false,
}
export interface metricDeploymentSliceState {
  metricDeployment: MetricDeployment[]
  selected_metricDeployment?: string
  is_loading_metricDeployment: boolean
  is_creating_metricDeployment: boolean
  is_deleting_metricDeployment: boolean
}
export const metricDeploymentSlice = createSlice({
  name: 'metricDeployment',
  initialState,
  reducers: {
    setSelectedmetricDeployment: (state, action) => {
      state.selected_metricDeployment = action.payload
    },
    clearStatemetricDeployment: (state) => {
      state.metricDeployment = []
      state.is_loading_metricDeployment = false
      state.is_creating_metricDeployment = false
      state.is_deleting_metricDeployment = false
    },
    mergemetricDeployment: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricDeployment = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricDeployment = merge(state.metricDeployment, payload) as any
        }
      }
    },

    add_metricDeployment: (state, action) => {
      if (action.payload) {
        state.metricDeployment = [...state.metricDeployment, action.payload]
      }
    },
    set_metricDeployment: (state, action) => {
      let { key, value, id } = action.payload
      state.metricDeployment = state.metricDeployment.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricDeploymentsAsync.pending, (state) => {
      state.is_loading_metricDeployment = true
    })
    builder.addCase(LoadMetricDeploymentsAsync.fulfilled, (state, action) => {
      state.is_loading_metricDeployment = false
      if (action.payload) {
        state.metricDeployment = action.payload
      }
    })
    builder.addCase(LoadMetricDeploymentsAsync.rejected, (state) => {
      state.is_loading_metricDeployment = false
    })
    builder.addCase(CreateMetricDeploymentAsync.pending, (state) => {
      state.is_creating_metricDeployment = true
    })
    builder.addCase(CreateMetricDeploymentAsync.fulfilled, (state) => {
      state.is_creating_metricDeployment = false
    })
    builder.addCase(CreateMetricDeploymentAsync.rejected, (state) => {
      state.is_creating_metricDeployment = false
    })
    builder.addCase(DeleteMetricDeploymentAsync.pending, (state) => {
      state.is_deleting_metricDeployment = true
    })
    builder.addCase(DeleteMetricDeploymentAsync.fulfilled, (state, action) => {
      state.is_deleting_metricDeployment = false
      if (state.metricDeployment) {
        state.metricDeployment = state.metricDeployment.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMetricDeploymentAsync.rejected, (state) => {
      state.is_deleting_metricDeployment = false
    })

    builder.addCase(autoThunks.get_metric_deployments.pending, (state) => {
      state.is_loading_metricDeployment = true
    })
    builder.addCase(
      autoThunks.get_metric_deployments.fulfilled,
      (state, action) => {
        state.is_loading_metricDeployment = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_metric_deployments.rejected, (state) => {
      state.is_loading_metricDeployment = false
    })

    builder.addCase(autoThunks.save_metric_deployment.pending, (state) => {
      state.is_loading_metricDeployment = true
    })
    builder.addCase(
      autoThunks.save_metric_deployment.fulfilled,
      (state, action) => {
        state.is_loading_metricDeployment = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.save_metric_deployment.rejected, (state) => {
      state.is_loading_metricDeployment = false
    })

    builder.addCase(autoThunks.enable_metric_deployment.pending, (state) => {
      state.is_loading_metricDeployment = true
    })
    builder.addCase(
      autoThunks.enable_metric_deployment.fulfilled,
      (state, action) => {
        state.is_loading_metricDeployment = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.enable_metric_deployment.rejected, (state) => {
      state.is_loading_metricDeployment = false
    })

    builder.addCase(autoThunks.delete_metric_deployment.pending, (state) => {
      state.is_loading_metricDeployment = true
    })
    builder.addCase(
      autoThunks.delete_metric_deployment.fulfilled,
      (state, action) => {
        state.is_loading_metricDeployment = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.delete_metric_deployment.rejected, (state) => {
      state.is_loading_metricDeployment = false
    })

    builder.addCase(
      autoThunks.get_available_metric_deployments.pending,
      (state) => {
        state.is_loading_metricDeployment = true
      },
    )
    builder.addCase(
      autoThunks.get_available_metric_deployments.fulfilled,
      (state, action) => {
        state.is_loading_metricDeployment = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.get_available_metric_deployments.rejected,
      (state) => {
        state.is_loading_metricDeployment = false
      },
    )
  },
})

function handleResult(action: any, state: metricDeploymentSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_metricDeployment = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.metricDeployment = merge(state.metricDeployment, payload) as any
    }
  }
}

export const {
  clearStatemetricDeployment,
  setSelectedmetricDeployment,
  set_metricDeployment,
  mergemetricDeployment,
  add_metricDeployment,
} = metricDeploymentSlice.actions

export const get_metricDeployment =
  (id?: string) =>
  (state: {
    metricDeployment: {
      metricDeployment: MetricDeployment[]
    }
  }): MetricDeployment | null => {
    let temp = state?.metricDeployment?.metricDeployment?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.metricDeployment?.metricDeployment[0] || null
  }
export const get_selected_metricDeployment = (state: {
  metricDeployment: metricDeploymentSliceState
}): MetricDeployment | null => {
  let id = state?.metricDeployment?.selected_metricDeployment
  let temp = state?.metricDeployment?.metricDeployment?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricDeployment = (state: {
  metricDeployment: {
    metricDeployment: MetricDeployment[]
  }
}): MetricDeployment[] => {
  let temp = state?.metricDeployment?.metricDeployment
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricDeployment_busy = (state: {
  metricDeployment: metricDeploymentSliceState
}) => {
  return (
    state?.metricDeployment.is_deleting_metricDeployment ||
    state?.metricDeployment.is_loading_metricDeployment ||
    state?.metricDeployment.is_creating_metricDeployment
  )
}
export const is_deleting_metricDeployment_busy = (state: {
  metricDeployment: metricDeploymentSliceState
}) => {
  return state?.metricDeployment.is_deleting_metricDeployment
}
export const is_loading_metricDeployment_busy = (state: {
  metricDeployment: metricDeploymentSliceState
}) => {
  return state?.metricDeployment.is_loading_metricDeployment
}
export const is_creating_metricDeployment_busy = (state: {
  metricDeployment: metricDeploymentSliceState
}) => {
  return state?.metricDeployment.is_creating_metricDeployment
}

export default metricDeploymentSlice.reducer
